import React from "react";
import useStringTranslation from "../../hooks/useStringTranslation";
import DetailCard from "./DetailCard";

export default function InformationFieldDisplay({ informationField }) {
  const value = useStringTranslation(
    informationField,
    "fieldValue",
    "fieldValueTranslation"
  );
  const title = useStringTranslation(
    informationField,
    "label",
    "labelTranslation"
  );

  return <DetailCard value={value} title={title} elevation={4} />;
}
